module.exports = "./src/client/assets/favicon-arma.ico?e2255f082e09b07666c4771e0e606544";